<script>
import BuyNow from './buy-now.vue';
import Edit from './edit.vue';
import EditDelta from './edit-delta.vue';
import Add from './add.vue';
import Trial2paid from './trial2paid.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.add2cart) return <Add on={this.$listeners} />;
    if (this.$context.is.edit) {
      if (this.$context.is.addQty) {
        return <EditDelta on={this.$listeners} />;
      } else {
        return <Edit on={this.$listeners} />;
      }
    }
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...{ props: { ...this.$props }}} on={this.$listeners} />;
    if (this.$context.is.trial2paid) return <Trial2paid on={this.$listeners} />;
    return null;
  },
};
</script>
